/**
 * ShareStatsPage - 分享统计
 * 显示分享码生成量、访问量、每日趋势
 */
import { useState, useEffect } from 'react'
import { Card, Statistic, Row, Col, Table, Tag, DatePicker, message } from 'antd'
import { ShareAltOutlined, EyeOutlined, RiseOutlined } from '@ant-design/icons'

export default function ShareStatsPage() {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(function() { loadStats(7) }, [])

  async function loadStats(days) {
    setLoading(true)
    try {
      var res = await fetch('/cms/api/showcase/stats?days=' + days)
      var data = await res.json()
      if (data.success) setStats(data.data)
    } catch(e) { message.error('加载失败') }
    setLoading(false)
  }

  var dailyColumns = [
    { title: '日期', dataIndex: 'dt', key: 'dt' },
    { title: '生成分享', dataIndex: 'cnt', key: 'cnt', render: function(v) { return <Tag color="blue">{v}</Tag> } },
  ]

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 24 }}>📊 分享统计</h2>

      <Row gutter={24} style={{ marginBottom: 24 }}>
        <Col span={8}>
          <Card><Statistic title="总分享次数" value={stats ? stats.total_shares : 0} prefix={<ShareAltOutlined />} /></Card>
        </Col>
        <Col span={8}>
          <Card><Statistic title="总访问次数" value={stats ? stats.total_visits : 0} prefix={<EyeOutlined />} /></Card>
        </Col>
        <Col span={8}>
          <Card><Statistic title="近7日分享" value={stats ? stats.recent_shares : 0} prefix={<RiseOutlined />} /></Card>
        </Col>
      </Row>

      <Card title="每日分享趋势">
        <Table
          dataSource={stats ? stats.daily_breakdown : []}
          columns={dailyColumns}
          pagination={false}
          size="small"
          rowKey="dt"
          loading={loading}
        />
      </Card>

      <Card title="每日访问趋势" style={{ marginTop: 16 }}>
        <Table
          dataSource={stats ? stats.visits_breakdown : []}
          columns={dailyColumns}
          pagination={false}
          size="small"
          rowKey="dt"
        />
      </Card>
    </div>
  )
}
